// stub for @kid/enterprise-icon/icon/output/icons
// 原包导出几百个图标常量；用 Proxy 兜底，让任何具名 import 都解析到一个字符串
// 这样像 `import { common_system_add } from '@kid/enterprise-icon/icon/output/icons'` 不会报 undefined
module.exports = new Proxy(
    {},
    {
        get: function (_target, prop) {
            if (prop === '__esModule') return true;
            if (typeof prop === 'symbol') return undefined;
            return String(prop);
        },
    }
);
